import type { InfraStatus } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/** Mirrors the shape services/gateway/src/routes/admin.ts GET returns: every
 *  allowlisted runtime_config key merged with its persisted value. */
export interface RuntimeConfigEntry {
  key: string
  description: string
  value: unknown
  updatedAt: string | null
}

/** FR seccion 10 (modo exclusivo) + PR seccion 6.1 (hot reload). `/admin`,
 *  host_owner only (Permission.ADMIN_CONFIG_WRITE gates this server-side). */
export function listAdminConfig(): Promise<{ entries: RuntimeConfigEntry[]; infraStatus: InfraStatus | null }> {
  return apiRequest("/api/v1/admin/config")
}

export function updateAdminConfig(key: string, value: unknown): Promise<{ config: RuntimeConfigEntry }> {
  return apiRequest(`/api/v1/admin/config/${key}`, { method: "PATCH", body: { value } })
}
